/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppExtension
 */
export interface AppExtension {
    /**
     * 
     * @type {string}
     * @memberof AppExtension
     */
    appId?: string;
    /**
     * 
     * @type {string}
     * @memberof AppExtension
     */
    appSecret?: string;
    /**
     * 
     * @type {number}
     * @memberof AppExtension
     */
    id?: number;
}

/**
 * Check if a given object implements the AppExtension interface.
 */
export function instanceOfAppExtension(value: object): value is AppExtension {
    return true;
}

export function AppExtensionFromJSON(json: any): AppExtension {
    return AppExtensionFromJSONTyped(json, false);
}

export function AppExtensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppExtension {
    if (json == null) {
        return json;
    }
    return {
        
        'appId': json['appId'] == null ? undefined : json['appId'],
        'appSecret': json['appSecret'] == null ? undefined : json['appSecret'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function AppExtensionToJSON(json: any): AppExtension {
    return AppExtensionToJSONTyped(json, false);
}

export function AppExtensionToJSONTyped(value?: AppExtension | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appId': value['appId'],
        'appSecret': value['appSecret'],
        'id': value['id'],
    };
}

